import * as types from '../constants/ActionTypes';

const initialState = {
  display: false,
  searchTopicPool: [],
  query: '',
  searchResult: [],
  empty: false,
  selectedIntent: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.GET_SEARCH_OBJECT:
      return { ...state, display: true, searchTopicPool: action.payload };
    case types.UPDATE_INTENT_QUERY:
      return { ...state, query: action.payload, empty: false };
    case types.CLEAR_INTENT_SUGGESTION:
      return { ...state, searchResult: [], empty: false };
    case types.CLEAR_ALL_INTENT:
      return {
        ...state, query: '', searchResult: [], empty: false,
      };
    case types.GET_INTENT_SUGGESTION:
      return { ...state, searchResult: action.payload, empty: false };
    case types.EMPTY_INTENT_SUGGESTION:
      return { ...state, searchResult: [], empty: true };
    case types.CRAWLING_SEARCH_TOPIC:
      return {
        ...state, display: false, searchResult: [], empty: false, selectedIntent: true,
      };
    case types.HIDE_INTENT_SUGGESTION:
      return { ...state, display: false };
    case types.SELECT_TOPIC: {
      if (action.payload.layer === 1) {
        return {
          ...state, display: true, query: '', searchResult: [], empty: false, selectedIntent: false,
        };
      }
      return {
        ...state, display: false, query: '', searchResult: [], empty: false, selectedIntent: false,
      };
    }
    default:
      return state;
  }
}
